var FontStyles;
(function (FontStyles) {
    FontStyles["Normal"] = "normal";
    FontStyles["Italic"] = "italic";
    FontStyles["Oblique"] = "oblique";
    FontStyles["Initial"] = "initial";
    FontStyles["Inherit"] = "inherit";
})(FontStyles || (FontStyles = {}));
export default FontStyles;
//# sourceMappingURL=fontStyles.js.map